import { BannerType } from '../components/banner';
import { FAQData } from '../components/faq/types';
import { NewsletterProps } from '../components/newsletter/types';
import { TestimonialProps } from '../components/testimonials/types';
import { IconCardProps } from '../components/types';
import { WhyUsCardProps } from '../components/why-is-important';

export const banner: BannerType = {
  heading: 'digitalFootprintLanding.mainBanner.title',
  subHeading: 'digitalFootprintLanding.mainBanner.subtitle',
  btnLabel: 'digitalFootprintLanding.mainBanner.buttonLabel',
  url: '/registrieren',
  youtubePlayer: {
    url: {
      en: 'https://www.youtube.com/watch?v=MgqZmBPdbtc',
      de: 'https://youtu.be/yan5V0-bhIQ',
      fr: 'https://www.youtube.com/watch?v=myJLVpswy_4',
      it: 'https://www.youtube.com/watch?v=SBocZvx3jP4',
    },
  },
  ytThumbnail: 'y_digitaler-nachlass.webp',
};

export const whyIsImportant: WhyUsCardProps[] = [
  {
    title: 'digitalFootprintLanding.aboutCards.documentAccounts.title',
    description:
      'digitalFootprintLanding.aboutCards.documentAccounts.description',
    icon: '/assets/icons/proactiveMeasure.svg',
  },
  {
    title: 'digitalFootprintLanding.aboutCards.connectDigitalValues.title',
    description:
      'digitalFootprintLanding.aboutCards.connectDigitalValues.description',
    icon: '/assets/icons/wishesYouCanAdapt.svg',
  },
  {
    title: 'digitalFootprintLanding.aboutCards.preserveDigitalData.title',
    description:
      'digitalFootprintLanding.aboutCards.preserveDigitalData.description',
    icon: '/assets/icons/inexpensive.svg',
  },
];

export const eightReasons: IconCardProps[] = [
  {
    title: 'provisionLanding.eightReasons.cards.card1.title',
    description:
      'provisionLanding.eightReasons.cards.card1.description.digitaler-nachlass',
    icon: '/assets/icons/whyUs1.svg',
  },
  {
    title: 'provisionLanding.eightReasons.cards.card2.title',
    description:
      'provisionLanding.eightReasons.cards.card2.description.digitaler-nachlass',
    icon: '/assets/icons/whyUs2.svg',
  },
  {
    title: 'provisionLanding.eightReasons.cards.card3.title',
    description:
      'provisionLanding.eightReasons.cards.card3.description.digitaler-nachlass',
    icon: '/assets/icons/conveniently.svg',
  },
  {
    title: 'provisionLanding.eightReasons.cards.card4.title',
    description:
      'provisionLanding.eightReasons.cards.card4.description.digitaler-nachlass',
    icon: '/assets/icons/costumisable.svg',
  },
  {
    title: 'provisionLanding.eightReasons.cards.card5.title',
    description:
      'provisionLanding.eightReasons.cards.card5.description.digitaler-nachlass',
    icon: '/assets/icons/enforceWishes.svg',
  },
  {
    title: 'provisionLanding.eightReasons.cards.card6.title',
    description:
      'provisionLanding.eightReasons.cards.card6.description.digitaler-nachlass',
    icon: '/assets/icons/mutualProtection.svg',
  },
  {
    title: 'provisionLanding.eightReasons.cards.card7.title',
    description:
      'provisionLanding.eightReasons.cards.card7.description.digitaler-nachlass',
    icon: '/assets/icons/access.svg',
  },
  {
    title: 'provisionLanding.eightReasons.cards.card8.title',
    description:
      'provisionLanding.eightReasons.cards.card8.description.digitaler-nachlass',
    icon: '/assets/icons/whyUs3.svg',
  },
];

export const testimonials: TestimonialProps[] = [
  {
    name: 'provisionLanding.testimonials.testimonial1.name',
    testimonial: 'provisionLanding.testimonials.testimonial1.text',
  },
  {
    name: 'provisionLanding.testimonials.testimonial2.name',
    testimonial: 'provisionLanding.testimonials.testimonial2.text',
  },
  {
    name: 'provisionLanding.testimonials.testimonial3.name',
    testimonial: 'provisionLanding.testimonials.testimonial3.text',
  },
];

export const secondBanner: BannerType = {
  heading: 'digitalFootprintLanding.subBanner.title',
  subHeading: 'digitalFootprintLanding.subBanner.subtitle',
  url: '/registrieren',
  btnLabel: 'digitalFootprintLanding.subBanner.buttonLabel',
  image:
    'https://storage.gutgeregelt.ch/assets/main-landings/banners/digitalFootprintBanner.webp',
};

export const faqData: FAQData = {
  questions: [
    {
      question: 'digitalFootprintLanding.faq.questions.question1',
      answer: 'digitalFootprintLanding.faq.answers.answer1',
    },
    {
      question: 'digitalFootprintLanding.faq.questions.question2',
      answer: 'digitalFootprintLanding.faq.answers.answer2',
    },
    {
      question: 'digitalFootprintLanding.faq.questions.question3',
      answer: 'digitalFootprintLanding.faq.answers.answer3',
    },
    {
      question: 'digitalFootprintLanding.faq.questions.question4',
      answer: 'digitalFootprintLanding.faq.answers.answer4',
    },
    {
      question: 'digitalFootprintLanding.faq.questions.question5',
      answer: 'digitalFootprintLanding.faq.answers.answer5',
    },
    {
      question: 'digitalFootprintLanding.faq.questions.question6',
      answer: 'digitalFootprintLanding.faq.answers.answer6',
    },
    {
      question: 'digitalFootprintLanding.faq.questions.question7',
      answer: 'digitalFootprintLanding.faq.answers.answer7',
    },
    {
      question: 'digitalFootprintLanding.faq.questions.question8',
      answer: 'digitalFootprintLanding.faq.answers.answer8',
    },
  ],
};

export const newsletter: NewsletterProps = {
  title: 'digitalFootprintLanding.newsletter.title',
  buttonLabel: 'digitalFootprintLanding.newsletter.buttonLabel',
  url: '/registrieren',
};
